import React from 'react';
import ActionRuleDetailSection from '../../../sections/AdminDashboard/Configuration/ActionRuleDetail';

const ActionRuleDetail = () => <ActionRuleDetailSection />;

export default ActionRuleDetail;
